import { useEffect } from "react";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { toast } from "@/shared/hooks/use-toast";

import { templatesApi } from "../api";
import type { GetTemplatesParams, PaginatedTemplates } from "../api";
import { templateKeys } from "./template.keys";

export function useTemplates(
  filters?: GetTemplatesParams,
  options?: Omit<UseQueryOptions<PaginatedTemplates, Error>, "queryKey" | "queryFn">,
) {
  const query = useQuery({
    queryKey: templateKeys.list(filters),
    queryFn: ({ signal }) => templatesApi.list(filters, signal),
    staleTime: 0,
    refetchOnMount: "always",
    ...(options as Omit<UseQueryOptions<PaginatedTemplates, Error>, "queryKey" | "queryFn">),
  });

  useEffect(() => {
    if (!query.error) return;
    toast({
      title: "Erro ao listar templates",
      description: query.error.message,
      variant: "destructive",
    });
  }, [query.error]);

  return {
    templates: query.data?.data ?? [],
    page: query.data?.page ?? filters?.page ?? 1,
    limit: query.data?.limit ?? filters?.limit ?? 10,
    totalPages: query.data?.totalPage ?? 1,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
    queryResult: query,
  };
}
